import { EnvironmentProviders, Injectable, inject, makeEnvironmentProviders } from '@angular/core';
import { DialogService, NEBULA_LOOKUP_WINDOW, NebulaLookupWindow } from 'nebula-ui-kit';
import { Observable, map } from 'rxjs';
import { BuscadorMaestroComponent } from '../../components/buscador-maestro/buscador-maestro.component';
import {
  BuscadorMaestroConfig,
  BuscadorMaestroResultado,
} from '../../components/buscador-maestro/buscador-maestro.models';

/** Abre la ventana de busqueda de maestros. */
@Injectable({ providedIn: 'root' })
export class BuscadorMaestroService {
  private readonly dialogos = inject(DialogService);

  /**
   * Abre la ventana con su configuracion.
   *
   * @param config columnas, consulta base, endpoint del page-response, idKey y si es multiple.
   * @returns lo elegido: [R] en seleccion unica, [R…] en multiple, o null si se cancela.
   */
  abrir<R extends Record<string, unknown>>(
    config: BuscadorMaestroConfig<R>,
  ): Observable<BuscadorMaestroResultado<R>> {
    return this.dialogos
      .open(BuscadorMaestroComponent<R>, { size: 'lg', data: { config } })
      .afterClosed()
      .pipe(map((r) => (Array.isArray(r) && r.length ? (r as R[]) : null)));
  }
}

/**
 * Registra la ventana como la que abre la lupa de los campos de codigo del kit (lookup.ventana).
 * Va una sola vez, en la configuracion de la aplicacion.
 *
 * @returns los proveedores del entorno.
 */
export function provideBuscadorMaestro(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: NEBULA_LOOKUP_WINDOW,
      useFactory: (): NebulaLookupWindow => {
        const servicio = inject(BuscadorMaestroService);
        return (ventana: unknown) => {
          const config = ventana as BuscadorMaestroConfig<Record<string, unknown>>;
          const adaptar = config.adaptar;
          return servicio
            .abrir(config)
            .pipe(map((elegidos) => (elegidos && adaptar ? elegidos.map(adaptar) : elegidos)));
        };
      },
    },
  ]);
}
